import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { Paciente } from '../../paciente';
import { DependenteService } from '../dependente.service';

@Component({
  selector: 'app-transferencia-titular-maintenance',
  templateUrl: './transferencia-titular-maintenance.component.html',
  styleUrls: ['./transferencia-titular-maintenance.component.css']
})
export class TransferenciaTitularMaintenanceComponent implements OnInit {

  id: number;

  dependente: Paciente;

  formularioTransferenciaTitular: FormGroup;

  tituloCrud: string = '';

  constructor(private dependenteService: DependenteService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog) {

    this.id = history.state.id;

    this.dependente = new Paciente();

    this.formularioTransferenciaTitular = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(6)]],
      cpf: ['', [Validators.required, CpfCnpjValidator.validate]],
      dataNascimento: ['', [Validators.required]],
      foneResidencial: [''],
      foneCelular: [''],
      dependentes: [[]],
      dependenteAtivo: [false],
      dependentesExcluidos: [[]],
    });
  }

  ngOnInit() {

    this.tituloCrud = 'Transferir Dependente para Titular';

    this.configurarForm();
  }

  save() {

    const nome: string = this.dependente.nome;
    const dataNascimento: Date = this.dependente.dataNascimento;

    this.dependente = Object.assign(new Paciente(), this.formularioTransferenciaTitular.value);

    this.dependente.nome = nome;
    this.dependente.dataNascimento = dataNascimento;

    if (this.dependente.foneCelular || this.dependente.foneResidencial) {

      this.dependenteService.transformarDependenteEmTitular(this.dependente)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Preencha pelo menos um número de telefone!'
        }
      });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/dependentes'], {
      state: {
        filtroDependente: history.state.filtroDependente,
      }
    });
  }

  get formControl() {
    return this.formularioTransferenciaTitular.controls;
  }

  configurarForm(): void {
    this.dependenteService.procurarDependentesPorIdIncluindoInativos(this.id)
      .subscribe(data => {
        // console.log(data)

        this.dependente = data;

        if (!this.dependente.cpf) {
          this.dependente.cpf = '';
        }

        this.formularioTransferenciaTitular.setValue(this.dependente);

        this.formularioTransferenciaTitular.controls.nome.disable();
        this.formularioTransferenciaTitular.controls.dataNascimento.disable();

        this.cd.detectChanges();

      }, error => {
        console.log(error);
      });
  }

}
